import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { authGuard } from '../helpers/auth.guard';
import { startupChildGuard } from '../helpers/startup.guard';
import { ChatService } from './app/chat/chat.service';
import { ModulesWrapperComponent } from './modules-wrapper/modules-wrapper.component';
import { ComponentsModule } from '../components/components.module';
import { CoreDirectivesModule } from 'src/@core/directives/directives';
import { DirectivesModule } from '../directives/directives.module';

const routes: Routes = [
  {
    path: 'invoicing/customer-portal',
    loadChildren: () =>
      import('./invoicing/customer-portal/customer-portal.module').then(
        (m) => m.CustomerPortalModule
      ),
  },
  {
    path: '',
    loadChildren: () => import('./main/main.module').then((m) => m.MainModule),
  },
  {
    path: '',
    component: ModulesWrapperComponent,
    canActivate: [authGuard],
    canActivateChild: [startupChildGuard],
    children: [
      {
        path: 'hr360',
        loadChildren: () =>
          import('./hr360/hr360.module').then((m) => m.Hr360Module),
        data: { menu: 'hr360' },
      },
      {
        path: 'i-nest',
        loadChildren: () =>
          import('./i-nest/i-nest.module').then((m) => m.INestModule),
        data: { menu: 'iNest' },
      },
      {
        path: 'i-team',
        loadChildren: () =>
          import('./i-team/i-team.module').then((m) => m.iTeamModule),
        data: { menu: 'iTeam' },
      },
      {
        path: 'lead-konnekt',
        loadChildren: () =>
          import('./lead-konnekt/lead-konnekt.module').then(
            (m) => m.LeadKonnektModule
          ),
        data: { menu: 'leadKonnekt' },
      },
      {
        path: 'setup',
        loadChildren: () =>
          import('./setup/setup.module').then((m) => m.SetupModule),
        data: { menu: 'setup' },
      },
      {
        path: 'movement-diary',
        loadChildren: () =>
          import('./movement-diary/movement-diary.module').then(
            (m) => m.MovementDiaryModule
          ),
        data: { menu: 'movementDiary', roles: ['employee'], right: 'Q' },
      },
      {
        path: 'invoicing',
        loadChildren: () =>
          import('./invoicing/invoicing.module').then((m) => m.InvoicingModule),
        data: { menu: 'invoice', roles: ['employee'], right: 'P' },
      },
      {
        path: 'app',
        loadChildren: () => import('./app/app.module').then((m) => m.AppModule),
        resolve: {
          chatServ: ChatService,
        },
      },
      {
        path: 'payment',
        loadChildren: () =>
          import('./payment/payment.module').then((m) => m.PaymentModule),
      },
    ]
  },
  {
    path: '**',
    redirectTo: '',
    pathMatch: 'full',
  },
];

@NgModule({
  declarations: [
    ModulesWrapperComponent
  ],
  imports: [
    CommonModule,
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'enabled',
      onSameUrlNavigation: 'reload',
    }),
    ComponentsModule,
    CoreDirectivesModule,
    DirectivesModule,
  ],
})
export class ModulesModule { }
